<ui-modal
  title="Catalog Search"
  size="lg"
  [showCloseButton]="true"
  (modalClosed)="onModalClosed()">

  <div style="overflow: auto; max-height: 70vh;">
    <app-catalog-search
      [searchTerm]="initialSearchTerm"
      [householdId]="householdId"
      [preselectProvider]="preselectProvider"
      (itemSelected)="onItemSelected($event)">
    </app-catalog-search>
  </div>

</ui-modal>
